// /src/stores/agent.js
import { defineStore } from 'pinia';

export const useAgentStore = defineStore('agent', {
  state: () => ({
    agentDetails: null,
    agentTrackId: null,
  }),
  actions: {
    setAgentDetails(details) {
      this.agentDetails = details;
      // persist in localStorage
      localStorage.setItem('agentDetails', JSON.stringify(details));
    },
    loadAgentDetails() {
      const stored = localStorage.getItem('agentDetails');
      if (stored) {
        this.agentDetails = JSON.parse(stored);
      }
    },
    clearAgentDetails() {
      this.agentDetails = null;
      localStorage.removeItem('agentDetails');
    },
    setAgent(agentData) {
      this.agentTrackId = agentData;
      localStorage.setItem('agentTrackId', agentData);
    },
    loadAgent() {
      const stored = localStorage.getItem('agentTrackId');
      if (stored) this.agentTrackId = stored;
    },
    clearAgent() {
      this.agentTrackId = null;
      localStorage.removeItem('agentTrackId');
    }
  }
});
